import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import RTFStyles from "./RTFStyles.module.css"

const DLeaf = ({ leaf, search }) => {
  console.log("DStarterLeaf", leaf)
  const { text, link, italic, bold, underline, sup } = leaf
  const styles = []
  if (italic) {
    styles.push(RTFStyles.italic)
  }
  if (bold) {
    styles.push(RTFStyles.bold)
  }
  if (underline) {
    styles.push(RTFStyles.underline)
  }
  if (link) {
    styles.push(RTFStyles.link)
  }
  if (sup) {
    styles.push(RTFStyles.sup)
  }
  let classNameString = ""
  styles.forEach(t => (classNameString += ` ${t}`))

  if (link) {
    return (
      <span
        onClick={() => search(`${link.book}-${link.chapter}-${link.verse}`)}
        className={classNameString}
      >
        {text}
      </span>
    )
  }
  return <span className={classNameString}>{text}</span>
}

export default DLeaf
